export default "__VITE_ASSET__D9nbwIu8__"